import { hostBridge } from '@publicala/delfino';
import type { TranslatePayload, TranslateResponse } from '@publicala/delfino';
import { DEFAULT_TRANSLATE_MOCK, isE2EMockActive } from '../../e2eMockGuard';

/**
 * Translate API for Volpe.
 * Provides methods to translate text via hostBridge.
 */
class TranslateAPI {
    /**
     * Translate text to target language.
     * Returns mock data in E2E standalone mode.
     *
     * @param payload - Translate parameters matching Delfino's TranslatePayload
     * @param payload.text - The text to translate
     * @param payload.targetLang - The target language code
     * @returns Translate response with translations
     */
    async translate(payload: TranslatePayload): Promise<TranslateResponse> {
        if (isE2EMockActive()) {
            return DEFAULT_TRANSLATE_MOCK;
        }
        return hostBridge.translate.translate(payload);
    }
}

export const translateAPI = new TranslateAPI();
